module.exports = __webpack_public_path__ + "static/media/left-lateral-flexion-up.70bc2547.png";